import { msgs } from "../define";

export const auth = msgs({
  en: {
    "login.title": "Sign in",
    "login.subtitle": "Welcome back. Sign in to run your salon.",
    "login.email": "Email",
    "login.password": "Password",
    "login.submit": "Sign in",
    "login.submitting": "Signing in…",
    "login.noAccount": "New to Senvia POS?",
    "login.createAccount": "Create a salon account",
    "login.error.invalid": "Email or password is incorrect.",
    "login.error.rate": "Too many attempts. Please wait a few minutes and try again.",
    "login.error.network": "Can't reach the server. Check your connection and try again.",
    "login.error.generic": "Sign in failed. Please try again.",
    "login.error.noSalon": "Your account isn't active in any salon yet. If your salon is still being set up, ask the owner to finish setup.",
    "signup.title": "Create your salon account",
    "signup.subtitle": "Set up in about 10 minutes. No card needed to start.",
    "signup.salonName": "Salon name",
    "signup.salonName.ph": "e.g. Aura Studio",
    "signup.name": "Your name",
    "signup.email": "Work email",
    "signup.password": "Password",
    "signup.password.hint": "At least 10 characters, with letters and numbers.",
    "signup.country": "Country",
    "signup.country.hint": "Sets your currency, time zone and tax defaults. You can change them later.",
    "signup.terms": "I agree to the Terms of Service (including Senvia's service fee on membership subscriptions and the Data Processing Addendum) and the Privacy Policy.",
    "signup.legal.terms": "Terms of Service", "signup.legal.privacy": "Privacy Policy", "signup.legal.dpa": "Data Processing Addendum", "signup.legal.subprocessors": "Subprocessors",
    "signup.submit": "Create my salon",
    "signup.submitting": "Creating your salon…",
    "signup.haveAccount": "Already have an account?",
    "signup.signIn": "Sign in",
    "signup.plan.title": "Base plan",
    "signup.plan.price": "USD 20 / month",
    "signup.plan.trial": "Free trial — billing starts later, cancel any time.",
    "signup.plan.f1": "Appointments & online-ready calendar",
    "signup.plan.f2": "Checkout with cash, card terminal or your own Stripe",
    "signup.plan.f3": "Customers, services and team in one place",
    "signup.plan.f4": "English, 中文 and Bahasa Melayu",
    "signup.error.email_taken": "An account with this email already exists. Sign in instead.",
    "signup.error.disposable_email": "Please use a permanent email address — disposable inboxes aren't accepted.",
    "signup.error.weak_password": "Choose a stronger password: at least 10 characters with letters and numbers.",
    "signup.error.terms_required": "Please accept the terms to continue.",
    "signup.error.country": "Choose your country.",
    "check.title": "Check your email",
    "check.body": "We sent a confirmation link to {email}. Please confirm your email to start using Senvia POS — the link works on any device.",
    "check.start": "Continue",
    "check.resend": "Resend email",
    "check.resent": "Sent again. It can take a minute to arrive.",
    "check.devLink": "Development mode (no SMTP): open the verification link",
    "verify.title": "Confirming your email…",
    "verify.ok.title": "Email confirmed",
    "verify.ok.body": "Thanks! {email} is confirmed.",
    "verify.continue": "Continue",
    "verify.fail.title": "This link can't be used",
    "verify.error.invalid_token": "This link is not valid. Request a new one from the app.",
    "verify.error.token_used": "This link has already been used. If your email is confirmed you're all set.",
    "verify.error.token_expired": "This link has expired. Sign in and request a new one.",
    "verify.missing": "The link is missing its token. Open the link from your email again.",
    "invite.title": "Join {salon}",
    "invite.body": "You've been invited to {salon} as {email}.",
    "invite.password": "Choose a password",
    "invite.accept": "Accept invitation",
    "invite.done.title": "You're in",
    "invite.done.body": "Your account for {salon} is ready. Sign in once the salon is live.",
    "invite.goLogin": "Go to sign in",
    "invite.invalid": "This invitation is not valid any more. Ask the salon to invite you again.",
  },
  zh: {
    "login.title": "登录",
    "login.subtitle": "欢迎回来，登录以管理您的店铺。",
    "login.email": "邮箱",
    "login.password": "密码",
    "login.submit": "登录",
    "login.submitting": "登录中…",
    "login.noAccount": "第一次使用 Senvia POS？",
    "login.createAccount": "创建店铺账户",
    "login.error.invalid": "邮箱或密码不正确。",
    "login.error.rate": "尝试次数过多，请稍等几分钟再试。",
    "login.error.network": "无法连接服务器，请检查网络后重试。",
    "login.error.generic": "登录失败，请重试。",
    "login.error.noSalon": "您的账户尚未在任何店铺中启用。如果店铺仍在设置中，请让店主先完成设置。",
    "signup.title": "创建您的店铺账户",
    "signup.subtitle": "大约 10 分钟即可完成设置，开始使用无需绑卡。",
    "signup.salonName": "店铺名称",
    "signup.salonName.ph": "例如：Aura 工作室",
    "signup.name": "您的姓名",
    "signup.email": "工作邮箱",
    "signup.password": "密码",
    "signup.password.hint": "至少 10 个字符，需包含字母和数字。",
    "signup.country": "国家/地区",
    "signup.country.hint": "用于设置货币、时区和税务默认值，之后可随时修改。",
    "signup.terms": "我同意服务条款（包括 Senvia 会员订阅服务费及数据处理附录）和隐私政策。",
    "signup.legal.terms": "服务条款", "signup.legal.privacy": "隐私政策", "signup.legal.dpa": "数据处理附录", "signup.legal.subprocessors": "分处理者",
    "signup.submit": "创建我的店铺",
    "signup.submitting": "正在创建店铺…",
    "signup.haveAccount": "已有账户？",
    "signup.signIn": "登录",
    "signup.plan.title": "基础版",
    "signup.plan.price": "每月 20 美元",
    "signup.plan.trial": "免费试用——稍后才开始计费，可随时取消。",
    "signup.plan.f1": "预约管理与日历",
    "signup.plan.f2": "支持现金、刷卡机或您自己的 Stripe 收款",
    "signup.plan.f3": "顾客、服务项目和团队统一管理",
    "signup.plan.f4": "支持 English、中文和 Bahasa Melayu",
    "signup.error.email_taken": "该邮箱已注册账户，请直接登录。",
    "signup.error.disposable_email": "请使用长期有效的邮箱，不接受临时邮箱。",
    "signup.error.weak_password": "请设置更安全的密码：至少 10 个字符，包含字母和数字。",
    "signup.error.terms_required": "请先同意条款再继续。",
    "signup.error.country": "请选择国家/地区。",
    "check.title": "请查收邮件",
    "check.body": "我们已向 {email} 发送确认链接。请先确认邮箱才能开始使用 Senvia POS —— 在任何设备上打开链接都可以。",
    "check.start": "继续",
    "check.resend": "重新发送邮件",
    "check.resent": "已重新发送，可能需要一分钟才能收到。",
    "check.devLink": "开发模式（未配置 SMTP）：打开验证链接",
    "verify.title": "正在确认您的邮箱…",
    "verify.ok.title": "邮箱已确认",
    "verify.ok.body": "谢谢！{email} 已确认。",
    "verify.continue": "继续",
    "verify.fail.title": "此链接无法使用",
    "verify.error.invalid_token": "此链接无效，请在应用中重新获取。",
    "verify.error.token_used": "此链接已被使用。如果邮箱已确认，则无需其他操作。",
    "verify.error.token_expired": "此链接已过期，请登录后重新获取。",
    "verify.missing": "链接缺少验证码，请从邮件中重新打开链接。",
    "invite.title": "加入 {salon}",
    "invite.body": "您已被邀请以 {email} 加入 {salon}。",
    "invite.password": "设置密码",
    "invite.accept": "接受邀请",
    "invite.done.title": "已加入",
    "invite.done.body": "您在 {salon} 的账户已就绪。店铺上线后即可登录。",
    "invite.goLogin": "前往登录",
    "invite.invalid": "此邀请已失效，请让店铺重新邀请您。",
  },
  ms: {
    "login.title": "Log masuk",
    "login.subtitle": "Selamat kembali. Log masuk untuk mengurus salun anda.",
    "login.email": "E-mel",
    "login.password": "Kata laluan",
    "login.submit": "Log masuk",
    "login.submitting": "Sedang log masuk…",
    "login.noAccount": "Baru menggunakan Senvia POS?",
    "login.createAccount": "Cipta akaun salun",
    "login.error.invalid": "E-mel atau kata laluan tidak betul.",
    "login.error.rate": "Terlalu banyak percubaan. Sila tunggu beberapa minit dan cuba lagi.",
    "login.error.network": "Tidak dapat menghubungi pelayan. Semak sambungan anda dan cuba lagi.",
    "login.error.generic": "Log masuk gagal. Sila cuba lagi.",
    "login.error.noSalon": "Akaun anda belum aktif di mana-mana salun. Jika salun masih dalam persediaan, minta pemilik melengkapkannya.",
    "signup.title": "Cipta akaun salun anda",
    "signup.subtitle": "Sedia dalam kira-kira 10 minit. Tiada kad diperlukan untuk bermula.",
    "signup.salonName": "Nama salun",
    "signup.salonName.ph": "cth. Aura Studio",
    "signup.name": "Nama anda",
    "signup.email": "E-mel kerja",
    "signup.password": "Kata laluan",
    "signup.password.hint": "Sekurang-kurangnya 10 aksara, dengan huruf dan nombor.",
    "signup.country": "Negara",
    "signup.country.hint": "Menetapkan mata wang, zon waktu dan cukai lalai. Boleh diubah kemudian.",
    "signup.terms": "Saya bersetuju dengan Terma Perkhidmatan (termasuk yuran perkhidmatan Senvia bagi langganan keahlian dan Adendum Pemprosesan Data) dan Dasar Privasi.",
    "signup.legal.terms": "Terms of Service", "signup.legal.privacy": "Privacy Policy", "signup.legal.dpa": "Data Processing Addendum", "signup.legal.subprocessors": "Subprocessors",
    "signup.submit": "Cipta salun saya",
    "signup.submitting": "Sedang mencipta salun anda…",
    "signup.haveAccount": "Sudah mempunyai akaun?",
    "signup.signIn": "Log masuk",
    "signup.plan.title": "Pelan Asas",
    "signup.plan.price": "USD 20 / bulan",
    "signup.plan.trial": "Percubaan percuma — bil bermula kemudian, batal bila-bila masa.",
    "signup.plan.f1": "Temujanji & kalendar",
    "signup.plan.f2": "Bayaran tunai, terminal kad atau Stripe anda sendiri",
    "signup.plan.f3": "Pelanggan, perkhidmatan dan pasukan di satu tempat",
    "signup.plan.f4": "English, 中文 dan Bahasa Melayu",
    "signup.error.email_taken": "Akaun dengan e-mel ini sudah wujud. Sila log masuk.",
    "signup.error.disposable_email": "Sila gunakan alamat e-mel tetap — peti mel sementara tidak diterima.",
    "signup.error.weak_password": "Pilih kata laluan yang lebih kukuh: sekurang-kurangnya 10 aksara dengan huruf dan nombor.",
    "signup.error.terms_required": "Sila terima terma untuk meneruskan.",
    "signup.error.country": "Pilih negara anda.",
    "check.title": "Semak e-mel anda",
    "check.body": "Kami telah menghantar pautan pengesahan ke {email}. Sila sahkan e-mel anda untuk mula menggunakan Senvia POS — pautan berfungsi pada mana-mana peranti.",
    "check.start": "Teruskan",
    "check.resend": "Hantar semula e-mel",
    "check.resent": "Telah dihantar semula. Mungkin mengambil masa seminit.",
    "check.devLink": "Mod pembangunan (tiada SMTP): buka pautan pengesahan",
    "verify.title": "Mengesahkan e-mel anda…",
    "verify.ok.title": "E-mel disahkan",
    "verify.ok.body": "Terima kasih! {email} telah disahkan.",
    "verify.continue": "Teruskan",
    "verify.fail.title": "Pautan ini tidak boleh digunakan",
    "verify.error.invalid_token": "Pautan ini tidak sah. Minta pautan baharu dalam aplikasi.",
    "verify.error.token_used": "Pautan ini telah digunakan. Jika e-mel anda sudah disahkan, tiada tindakan lanjut diperlukan.",
    "verify.error.token_expired": "Pautan ini telah tamat tempoh. Log masuk dan minta pautan baharu.",
    "verify.missing": "Pautan tidak lengkap. Buka semula pautan daripada e-mel anda.",
    "invite.title": "Sertai {salon}",
    "invite.body": "Anda dijemput ke {salon} sebagai {email}.",
    "invite.password": "Pilih kata laluan",
    "invite.accept": "Terima jemputan",
    "invite.done.title": "Anda telah menyertai",
    "invite.done.body": "Akaun anda untuk {salon} sudah sedia. Log masuk apabila salun mula beroperasi.",
    "invite.goLogin": "Pergi ke log masuk",
    "invite.invalid": "Jemputan ini tidak sah lagi. Minta salun menjemput anda semula.",
  },
});
